import React from "react";
function Blur(props) {
  const { className = "", style = {}, children, block = false } = props;
  const classNames = [className, "Blur"];
  if (block) {
    style.display = "block";
  }
  return /*#__PURE__*/ React.createElement(
    "span",
    { className: classNames.join(" "), style: style },
    children
  );
}

function BlurryText(props) {
  const { className = "", style = {}, value = "", word = false } = props;
  if (!word) {
    return /*#__PURE__*/ React.createElement(
      Blur,
      { className: className, style: style },
      value
    );
  }
  return /*#__PURE__*/ React.createElement(
    "span",
    { className: className, style: style },
    value.split(" ").map((character, i) => {
      return /*#__PURE__*/ React.createElement(
        React.Fragment,
        null /*#__PURE__*/,
        React.createElement(Blur, { key: i }, character) /*#__PURE__*/,
        React.createElement("span", null, " ")
      );
    })
  );
}

export default BlurryText;
